import { useState } from "react";
import { SelectBuscable } from "../../components/SelectBuscable";

const diasSemana = {
  1: "Lunes",
  2: "Martes",
  3: "Miércoles",
  4: "Jueves",
  5: "Viernes",
  6: "Sábado",
  7: "Domingo",
};

const botonAccion = (bg, color) => ({
  width: 30, height: 30, borderRadius: 9, border: 'none',
  background: bg, color, cursor: 'pointer', fontSize: 12,
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
})

const inputStyle = {
  width: '100%', padding: '8px 10px', borderRadius: 8,
  border: '1.5px solid #e2e8f0',
  boxSizing: 'border-box', fontSize: 13.5, background: 'white',
  outline: 'none', color: '#0f172a',
};

export default function TiposAtenHorarios({
  show,
  onClose,
  tipoAtencion,
  horarios,
  onAdd,
  onEdit,
  onDelete,
}) {
  const [editingId, setEditingId] = useState(null);
  const [editValues, setEditValues] = useState({});
  const [nuevoDia, setNuevoDia] = useState('1');

  const handleEditClick = (h) => {
    setEditingId(h.ideAgenda);
    setEditValues({ ...h });
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditValues({});
  };

  const handleSaveEdit = () => {
    onEdit(editValues); // Llama al PUT en el front
    setEditingId(null);
    setEditValues({});
  };

  const handleChange = (field, value) => {
    setEditValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleAdd = () => {
    const start_time = document.getElementById("nuevoInicio").value;
    const end_time = document.getElementById("nuevoFin").value;
    onAdd({ ideDia: nuevoDia, start_time, end_time });
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(15, 23, 42, 0.65)', backdropFilter: 'blur(6px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 20, fontFamily: "'Inter', Arial, sans-serif",
    }}>
      <div style={{
        background: '#ffffff', borderRadius: 24, width: '100%',
        maxWidth: 720, maxHeight: '92vh', overflowY: 'auto',
        boxShadow: '0 25px 60px rgba(0,0,0,0.25)', border: '1px solid #e2e8f0',
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-primario-oscuro) 100%)',
          padding: '20px 26px', color: 'var(--color-primario-contraste)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          position: 'sticky', top: 0, zIndex: 1,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{
              width: 44, height: 44, borderRadius: 14,
              background: 'rgba(255,255,255,0.18)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 20,
            }}>
              <i className="fa-solid fa-clock"></i>
            </div>
            <div>
              <h4 style={{ margin: 0, fontWeight: 800, fontSize: 18 }}>Horarios de Atención</h4>
              <p style={{ margin: '3px 0 0', opacity: 0.85, fontSize: 12.5 }}>
                {tipoAtencion?.nombre ?? ''}
              </p>
            </div>
          </div>
          <button type="button" onClick={onClose} style={{
            background: 'rgba(255,255,255,0.15)', border: 'none', color: 'var(--color-primario-contraste)',
            width: 34, height: 34, borderRadius: '50%', fontSize: 16, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}><i className="fa-solid fa-xmark"></i></button>
        </div>

        <div style={{ padding: 26 }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13.5, minWidth: 560 }}>
              <thead>
                <tr style={{ background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-primario-oscuro) 100%)', color: 'var(--color-primario-contraste)' }}>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 700 }}>Día</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 700 }}>Hora Inicio</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 700 }}>Hora Fin</th>
                  <th style={{ padding: '12px 16px', textAlign: 'center', fontWeight: 700, width: 110 }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {horarios.length === 0 && (
                  <tr>
                    <td colSpan={4} style={{ padding: '30px 16px', textAlign: 'center', color: '#94a3b8', fontWeight: 600 }}>
                      No hay horarios registrados. Agrega uno en la fila inferior.
                    </td>
                  </tr>
                )}
                {horarios.map((h, idx) => (
                  <tr key={h.ideAgenda} style={{
                    borderBottom: '1px solid #f1f5f9',
                    background: idx % 2 === 0 ? '#ffffff' : '#f8fafc',
                  }}>
                    <td style={{ padding: '10px 16px' }}>
                      {editingId === h.ideAgenda ? (
                        <SelectBuscable
                          options={Object.entries(diasSemana).map(([k, v]) => ({ value: k, label: v }))}
                          value={editValues.ideDia}
                          onChange={(value) => handleChange("ideDia", parseInt(value, 10))}
                          isClearable={false}
                          fontSize="13px"
                          height={34}
                        />
                      ) : (
                        <span style={{ fontWeight: 700, color: '#0f172a' }}>{diasSemana[h.ideDia]}</span>
                      )}
                    </td>
                    <td style={{ padding: '10px 16px' }}>
                      {editingId === h.ideAgenda ? (
                        <input
                          type="time"
                          value={editValues.start_time}
                          onChange={(e) => handleChange("start_time", e.target.value)}
                          style={inputStyle}
                        />
                      ) : (
                        h.start_time
                      )}
                    </td>
                    <td style={{ padding: '10px 16px' }}>
                      {editingId === h.ideAgenda ? (
                        <input
                          type="time"
                          value={editValues.end_time}
                          onChange={(e) => handleChange("end_time", e.target.value)}
                          style={inputStyle}
                        />
                      ) : (
                        h.end_time
                      )}
                    </td>
                    <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                      <div style={{ display: 'inline-flex', gap: 6 }}>
                        {editingId === h.ideAgenda ? (
                          <>
                            <button title="Guardar" style={botonAccion('#d1fae5', '#047857')} onClick={handleSaveEdit}>
                              <i className="fa-solid fa-check"></i>
                            </button>
                            <button title="Cancelar" style={botonAccion('#e2e8f0', '#475569')} onClick={handleCancelEdit}>
                              <i className="fa-solid fa-xmark"></i>
                            </button>
                          </>
                        ) : (
                          <>
                            <button title="Editar" style={botonAccion('#fef3c7', '#92400e')} onClick={() => handleEditClick(h)}>
                              <i className="fa-solid fa-pen"></i>
                            </button>
                            <button title="Eliminar" style={botonAccion('#fee2e2', '#b91c1c')} onClick={() => onDelete(h.ideAgenda)}>
                              <i className="fa-solid fa-trash"></i>
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
                <tr style={{ background: '#f8fafc' }}>
                  <td style={{ padding: '10px 16px' }}>
                    <SelectBuscable
                      options={Object.entries(diasSemana).map(([k, v]) => ({ value: k, label: v }))}
                      value={nuevoDia}
                      onChange={(value) => setNuevoDia(value)}
                      isClearable={false}
                      fontSize="13px"
                      height={34}
                    />
                  </td>
                  <td style={{ padding: '10px 16px' }}>
                    <input type="time" id="nuevoInicio" style={inputStyle} />
                  </td>
                  <td style={{ padding: '10px 16px' }}>
                    <input type="time" id="nuevoFin" style={inputStyle} />
                  </td>
                  <td style={{ padding: '10px 16px', textAlign: 'center' }}>
                    <button title="Agregar horario" style={botonAccion('var(--color-secundario-suave)', 'var(--color-primario)')} onClick={handleAdd}>
                      <i className="fa-solid fa-plus"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 22 }}>
            <button type="button" onClick={onClose} style={{
              padding: '12px 24px', borderRadius: 12, border: 'none',
              background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
              color: 'var(--color-marca-contraste)', fontWeight: 800, cursor: 'pointer', fontSize: 14,
              boxShadow: '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
              display: 'inline-flex', alignItems: 'center', gap: 8,
            }}>
              <i className="fa-solid fa-check"></i> Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}